import * as t from 'type-shift';
import { loggedInFetch } from '../authentication';

const pricingTierConverter = t.number;
export interface PricingTier {
  name: string;
  price: number;
}

export const fetchPricingTiersApi = async () => {
  const response = await loggedInFetch('/api/pricing-tiers');
  if (response.ok) {
    const json = await response.json();
    const result = t.record(pricingTierConverter)(json);
    return Object.entries(result).map(([name, tier]) => ({
      name,
      price: tier
    })) as PricingTier[];
  }
  throw new Error(
    `Error fetching pricing tiers, status: ${response.status}, text: ${response.statusText}`
  );
};
